// Central content store — every business fact here is an EDITABLE PLACEHOLDER
// until ARD Midsouth Performance supplies the real details.

// FAQs — answers are editable placeholders where details aren't final yet.
export const FAQS = [
  {
    q: "What ages do you train?",
    a: "ARD Midsouth Performance trains players in three age-specific programs: 7–9 (First Touch Academy), 10–12 (Elite Development), and 13–15 (Performance Track). Not sure where your player fits? Register and our staff will help place them.",
  },
  {
    q: "Where are sessions held?",
    a: "Exact training location shared after registration.",
  },
  {
    q: "What are the training days, times, and pricing?",
    a: "Winter Session 1 runs Mondays & Thursdays, 5:00–6:00 PM, November 9 – December 7 — 8 sessions total (Nov 9, 12, 16, 19, 23, 30, Dec 3, Dec 7). All three age groups (7–9, 10–12, 13–15) train on the same days and time. Cost is $275 per player, plus a $5 online payment fee, with secure online card checkout at the end of registration.",
  },
  {
    q: "How do I sign my player up?",
    a: "Click any \"Sign Up For Training\" button, complete the quick registration form (player + guardian details and age group), then review and sign the liability waiver. That's it — you're on our list and we'll be in touch with next steps.",
  },
  {
    q: "Is a waiver required?",
    a: "Yes. Every participant must have a signed liability waiver on file before training. You'll be prompted to sign it right after registering, and you'll receive an emailed copy for your records. If you don't finish it right away, we'll send a reminder with a link to complete it.",
  },
  {
    q: "What should my player bring to training?",
    a: "Cleats, shin guards, a size-appropriate ball, a water bottle, and weather-appropriate athletic clothing. (Specific equipment details — editable placeholder.)",
  },
  {
    q: "What happens if it rains or weather is bad?",
    a: "In the event of inclement weather, sessions may be rescheduled or moved. Our staff will notify registered families directly.",
  },
  {
    q: "Who are the coaches?",
    a: "ARD is led by two licensed head coaches and co-founders: Ethan McClure (USSF C License, Head Coach at Northpoint Christian School) and Enda Crehan (UEFA A License, Head Coach at CBU). Learn more on the About page.",
  },
  {
    q: "How can I get in touch?",
    a: "Use the Contact page to send us a message, or reach a coach directly by email or phone listed in the site footer. We're happy to answer any questions before you sign up.",
  },
];


export const CONTACT = {
  email: "tethanmcclure@gmail.com",
  phone: "(901) 652-8634",
  location: "DeSoto County & Greater Memphis Area",
  serviceArea: "DeSoto County, MS & the greater Memphis area",
  instagram: "https://www.instagram.com/ard_performance_training_/",
};

export const STAFF_CONTACTS = [
  { name: "Ethan McClure", email: "tethanmcclure@gmail.com", phone: "(901) 652-8634" },
  { name: "Enda Crehan", email: "endacrehan1984@gmail.com", phone: "(434) 549-3377" },
];

export const SESSION_INFO = {
  name: "Winter Session 1",
  start: "Starts Monday, November 9th",
  cadence: "Mondays & Thursdays · 5:00–6:00 PM · 8 sessions",
  dates: ["Nov 9", "Nov 12", "Nov 16", "Nov 19", "Nov 23", "Nov 30", "Dec 3", "Dec 7"],
  price: "$275 per player",
};


export const AGE_GROUPS = [
  {
    id: "7-9",
    label: "AGES 7–9",
    tag: "FOUNDATION",
    title: "First Touch Academy",
    blurb:
      "Where the love of the game is built. Fundamental ball mastery, coordination and confidence through high-energy, game-based sessions.",
    focus: ["Ball control & first touch", "Coordination & agility", "Fun, game-based learning", "Confidence on the ball"],
    image: "https://images.unsplash.com/photo-1600077063877-22118d6290eb",
    schedule: "Winter Session 1 · Mon & Thu · 5:00–6:00 PM · Nov 9–Dec 7",
    price: "$275 per player",
  },
  {
    id: "10-12",
    label: "AGES 10–12",
    tag: "DEVELOPMENT",
    title: "Elite Development",
    blurb:
      "Technical refinement meets tactical awareness. Players sharpen decision-making, positioning and 1v1 dominance.",
    focus: ["Advanced technical work", "Tactical awareness", "1v1 attacking & defending", "Speed & change of direction"],
    image: "https://images.pexels.com/photos/16248872/pexels-photo-16248872.jpeg",
    schedule: "Winter Session 1 · Mon & Thu · 5:00–6:00 PM · Nov 9–Dec 7",
    price: "$275 per player",
  },
  {
    id: "13-15",
    label: "AGES 13–15",
    tag: "PERFORMANCE",
    title: "Performance Track",
    blurb:
      "High-performance training for the committed player. Position-specific mastery, athletic development and a competitive edge.",
    focus: ["Position-specific mastery", "Strength & athletic performance", "Game intelligence", "College & club preparation"],
    image: "https://images.unsplash.com/photo-1759674794418-26371e3851a9",
    schedule: "Winter Session 1 · Mon & Thu · 5:00–6:00 PM · Nov 9–Dec 7",
    price: "$275 per player",
  },
];

export const BENEFITS = [
  { n: "01", title: "Elite Coaching", text: "Small-group, high-touch coaching built to accelerate every player's development." },
  { n: "02", title: "Game-Realistic Training", text: "Sessions engineered around real match situations, not lines and cones." },
  { n: "03", title: "Individual Development", text: "Each player is tracked and pushed to their next level, at their own pace." },
  { n: "04", title: "Local & Accessible", text: "Serving DeSoto County and the greater Memphis area — training close to home." },
];

export const MANIFESTO = [
  { n: "01", title: "Master the Ball", text: "Everything starts with a relationship with the ball. We build it touch by touch, rep by rep, until it's instinct." },
  { n: "02", title: "Train the Mind", text: "Speed of thought wins games. We coach players to read, decide and execute faster than the game demands." },
  { n: "03", title: "Compete Every Day", text: "Standards are set in the details. We create an environment where competing hard is simply how we operate." },
];

export const TESTIMONIALS = [
  { quote: "My son had an incredible experience at the summer camp and looked forward to going back each day. The coaches were attentive to each player's strengths and weaknesses and offered direct, impactful instruction. I highly recommend ARD Midsouth to anyone looking for a camp that will build their child's confidence, skills, and love for the game!", name: "Nate P.", role: "Camp Parent" },
  { quote: "My sons (ages 7 & 9) got to train with Coach Enda and Coach Ethan. They both really loved the intensity of the training and challenge of applying their skills in small sided games. We really enjoyed the mixed age groups and style of coaching!", name: "Brook D.", role: "Camp Parent" },
];

export const COACHES = [
  {
    name: "Ethan McClure",
    role: "Co-Founder",
    credential: "USSF C License",
    title: "Head Coach — Northpoint Christian School",
    bio: "Co-founder of ARD Midsouth Performance and Head Coach at Northpoint Christian School. USSF C licensed, Ethan brings a technical, development-first approach to every session.",
    email: "tethanmcclure@gmail.com",
    phone: "(901) 652-8634",
    highlights: [
      "USSF C Licensed coach",
      "Head Coach — Northpoint Christian School",
      "Youth technical development specialist", // EDIT ME
    ],
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_ard-elite-soccer/artifacts/5ud18mjx_image.png",
  },
  {
    name: "Enda Crehan",
    role: "Co-Founder",
    credential: "UEFA A License",
    title: "Head Coach — Christian Brothers University",
    bio: "Co-founder of ARD Midsouth Performance and Head Coach at Christian Brothers University. UEFA A licensed, Enda brings elite tactical and performance coaching to the program.",
    email: "endacrehan1984@gmail.com",
    phone: "(434) 549-3377",
    highlights: [
      "UEFA A Licensed coach",
      "Head Coach — Christian Brothers University (CBU)",
      "College & elite-level coaching experience", // EDIT ME
    ],
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_ard-elite-soccer/artifacts/dx0s8dc8_image.png",
  },
];

export const GALLERY = [
  "https://customer-assets-0z36b82j.emergentagent.net/job_ard-elite-soccer/artifacts/fy3pp3ud_ARD%201.2.jpg",
  "https://customer-assets-0z36b82j.emergentagent.net/job_ard-elite-soccer/artifacts/rsa6slou_Ard%202%20.jpg",
  "https://customer-assets-0z36b82j.emergentagent.net/job_ard-elite-soccer/artifacts/awthj0w4_ard%2012.webp",
  "https://customer-assets-0z36b82j.emergentagent.net/job_ard-elite-soccer/artifacts/mhar5xi3_Ard%203.jpg",
  "https://customer-assets-0z36b82j.emergentagent.net/job_ard-elite-soccer/artifacts/fbbzqarz_ARD%204%20.jpg",
];

export const HERO_IMAGE =
  "https://customer-assets-0z36b82j.emergentagent.net/job_ard-elite-soccer/artifacts/fbbzqarz_ARD%204%20.jpg";
export const MANIFESTO_IMAGE =
  "https://images.unsplash.com/photo-1517466787929-bc90951d0974";
